module.exports = __webpack_public_path__ + "img/chrome_imported_cert.c5f99db5.png";